module.exports = __webpack_public_path__ + "static/media/group.72ff8d26.png";